import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../../badge';
import Tooltip from '../../tooltip';

const RenBadge = ({ data, accessor }) => {
  const getBadge = () => {
    if (data[accessor].tooltip) {
      return (
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        <Tooltip {...data[accessor].tooltip}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Badge {...data[accessor]} />
        </Tooltip>
      );
    }
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    return <Badge {...data[accessor]} />;
  };
  return (
    <div className="tbl-ren-badge">
      {getBadge()}
    </div>
  );
};

RenBadge.defaultProps = {
  id: '',
  data: {},
};

RenBadge.propTypes = {
  id: PropTypes.string,
  accessor: PropTypes.string.isRequired,
  data: PropTypes.shape(),
};

export default RenBadge;
